// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import CookIslands from '../_raw/flag/icon_flag_cook_islands.png';

export default () => <img src={CookIslands} alt="CookIslands" />;
